const PaginationArrowRightIcon = (props) => (
    <svg width="6" height="10" viewBox="0 0 6 10" {...props}  xmlns="http://www.w3.org/2000/svg">
    <path d="M3.78132 4.99999L0.481323 1.69999L1.42399 0.757324L5.66666 4.99999L1.42399 9.24266L0.481323 8.29999L3.78132 4.99999Z"/>
    </svg>
    );
    
    export default PaginationArrowRightIcon;